<div class="feature-button">
  <p class="feature-button_name">{{ featureNavOption }}</p>
  <stxt-svg-icon class="feature-button_icon" [iconConfig]="buttonIcon"></stxt-svg-icon>
</div>
